export const privacyPolicyData = {
  title: 'Privacy Policy',
  description:
    'We love our customers and their privacy is our topmost priority as it is most valuable.',
  information: [
    `Protecting the personal information of our customers is a significant responsibility of any organization, so we take it very seriously. Optimity Logics secures privacy by providing transparency and choice regarding protecting the privacy of our clients’ personal information as well as visitors to our website.`,
    `This privacy policy describes what data Optimity Logics (herein referred to as “We,” “Our,” or “Us”) collects, stores, and processes about you. It also explains your rights to your data and the way to contact us in case of any questions. We hold the right to reconstruct this privacy statement at our discretion and encourage you to check this section from time to time to be aware of any changes.`,
  ],
  informationList: [
    {
      heading: 'Applicable To',
      description: [
        'This privacy statement refers to people (“Users” or “You”) who interact with our website, subscribe to any of our blogs, request information, or use the chat support.',
      ],
    },
    {
      heading: 'How We Collect Data',
      description: [
        'Depending on the services you use, i.e., blogs, request information through Contact Us, or use the chat support, we collect data from one or more of these three sources.',
      ],
      list: [
        {
          heading: ' Data we request',
          description:
            'We may ask for, store, and process any/all of the data mentioned after getting your permission when you request any of our services:',
          itemList: [
            'Your Name',
            'Your Country',
            'Your Email ID',
            'Your Phone Number',
          ],
        },
        {
          heading: 'Cookies',
          description:
            'Cookies are small files stored on your device when you visit our website. These help us understand website traffic, analyze user behavior, enhance site performance, and personalize your browsing experience. Cookies also allow us to remember your preferences and deliver more relevant content and advertisements.',
        },
      ],
    },
    {
      heading: 'Types of Cookies We Use',
      itemList: [
        'Essential Cookies: Enable basic site functionality and ensure secure access.',
        'Performance Cookies: Help us understand how users interact with our website to improve functionality and user experience.',
        'Functional Cookies: Remember your preferences—such as language, region, or layout—to offer a customized browsing experience.',
        'Marketing Cookies: Track your interactions to help us deliver targeted advertisements and promotional content based on your interests.',
      ],
    },
    {
      heading: 'Use of Third-Party Tools',
      description:
        'We may use trusted third-party tools for analytics, advertising, remarketing, and user engagement. These tools may collect data about your visits to our website and other websites to help us:',
      description1:
        'These tools operate under their own privacy policies. While we work with reliable partners, Optimity Logics is not responsible for how these third parties manage your data. We recommend reviewing their privacy terms for full transparency.',
      itemList: [
        'Analyze visitor behavior',
        'Show you personalized ads across different platforms',
        'Measure the effectiveness of our campaigns',
      ],
    },
    {
      heading: 'How We Use Submitted Information',
      description:
        'By submitting your contact details (such as name, email address, or phone number), you agree that Optimity Logics may use this information to:',
      description1:
        'You can opt out of marketing communications at any time using the unsubscribe link in our emails.',
      itemList: [
        'Respond to your inquiries or support requests',
        'Send you promotional emails, newsletters, and other marketing content',
        'Contact you via phone, SMS, or email — including occasional cold outreach — to introduce our services or respond to potential business interests',
      ],
    },
    {
      heading: 'Managing Your Cookie Preferences',
      description:
        'You can manage or disable cookies through your browser settings. If you prefer not to be tracked, use incognito/private browsing mode. By continuing to use our website or by submitting your information, you consent to the use of cookies and the data practices described above.',
    },
    {
      heading: 'Why Do We Collect Your Data Once You Permit?',
      description: 'Following are reasons for collecting data:',
      itemList: [
        'To communicate with you regarding services that you inquired about or for current projects with us.',
        'To notify you (using email) if there will be any changes to this Privacy Policy, Terms of Service, or important notices.',
        'To keep you updated with new products and services provided by us, upcoming events, offers, and promotions of interest to you.',
        'For providing our services as requested by you through various means, such as enabling collaboration, requirement gathering, project development, and deployment of a project.',
        'To provide good customer support and analyze our interactions with customers.',
        'To recognize and block fraudulent transactions and other unauthorized activities, to report spam, and to protect the rights and interests of Optimity Logics and its users.',
        'To update, expand, and investigate our records, identify new customers, and provide products and services that may be of interest to you.',
        'To manage our website and track website visitor navigations to understand their behavior and interests for better support.',
        'To observe and enhance our marketing campaigns and make suggestions relevant to the user.',
      ],
    },
    {
      heading: 'Do We Share Your Personal Data?',
      description:
        'We never share your personal data with any third party under any circumstances.',
    },
    {
      heading: 'How Do We Protect Your Information?',
      descriptionList: [
        'We do not reveal any information provided by you; the only reason we collect your details is to establish ready communication with you and present you with the required service. During this procedure, we take complete care to use the information in the most authentic manner so that there remain no loopholes and dangers of any sort of information leakage or exposure.',
        'While surfing our website, you may find a few forms or fields asking for your information, like your name, contact number, etc. Our privacy policy assures you that any details filled or data entered in the form will not be misused, sold, and/or rented by any means or conditions. We don’t sell, rent, or share it with any third party, and we don’t ever misuse any of the information provided by any means. However, the data may be used for future communication and internal record-keeping purposes.',
        'We maintain a significant level of control over how the information is handled, used, and stored. Our privacy policy ensures a trustworthy and secure association in every way possible!',
      ],
    },
    {
      heading: 'Authority Provided To You',
      description:
        'You have complete control over your information we store and its usage. Following are the choices you can do:',
      itemList: [
        'Hit Unsubscribe from the incoming mails from our end and change notification preferences to stop receiving emails and notifications from our website.',
        'You can choose not to share your information by not filling out any form.',
        'You can choose not to share your information by not using the chat support.',
        'You can at any time change your consent earlier provided for any specific use of your data.',
        'If you have any questions regarding our privacy policy or data handling practices, we would be glad to hear from you at <a href="mailto:info@optimitylogics.com" class="font-bold underline">info@optimitylogics.com</a>',
      ],
    },
    {
      heading: 'Beware of Sharpies',
      descriptionList: [
        'This is the official global website of Optimity Logics. We do not operate any other website domain and do not request any payments (for example, related to recruitment) unless it’s related to an official client project. Be cautious of scammers posing as us.',
        'Optimity Logics will not be liable for any losses incurred if you fall victim to such scams, knowingly or unknowingly. If you encounter any suspicious activity, report it directly to us through the provided contact details, or you can also report phishing to Google directly. Stay vigilant, and thank you for your cooperation.',
      ],
    },
  ],
};
